import { FiTruck, FiShield, FiRefreshCw } from "react-icons/fi";
import { BsPatchCheck } from "react-icons/bs";
import { motion } from "framer-motion";
import { T } from "../../constants/theme";

export default function TrustStrip() {
  const items = [
    {
      icon: <FiTruck size={22} />,
      title: "LIVE IOT DATA",
      sub: "Real sensors, real farms",
    },
    {
      icon: <FiRefreshCw size={22} />,
      title: "TRANSPARENT RETURNS",
      sub: "Track funding & payouts",
    },
    {
      icon: <FiShield size={22} />,
      title: "SECURE PAYMENTS",
      sub: "SSL Protected",
    },
    {
      icon: <BsPatchCheck size={22} />,
      title: "VETTED PROJECTS",
      sub: "Verified growers only",
    },
  ];

  return (
    <section
      style={{
        background: T.paper,
        borderTop: `1px solid ${T.gold}`,
        borderBottom: `1px solid ${T.border}`,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          maxWidth: 1500,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(4,1fr)",
          alignItems: "center",
        }}
      >
        {items.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: .6,
              delay: index * .12,
            }}
            whileHover={{
              y: -3,
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 18,
              padding: "26px 34px",
              position: "relative",
              cursor: "default",
            }}
          >
            {index !== 3 && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "25%",
                  height: "50%",
                  width: 1,
                  background: "rgba(255,255,255,.12)",
                }}
              />
            )}

            <motion.div
              whileHover={{
                rotate: 6,
                color: T.gold,
              }}
              transition={{
                duration: .3,
              }}
              style={{
                color: T.ink,
                flexShrink: 0,
              }}
            >
              {item.icon}
            </motion.div>

            <div>
              <div
                style={{
                  color: T.ink,
                  fontSize: 12,
                  letterSpacing: ".18em",
                  fontWeight: 700,
                }}
              >
                {item.title}
              </div>

              <div
                style={{
                  marginTop: 6,
                  color: T.muted,
                  fontSize: 13,
                }}
              >
                {item.sub}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
